if (!customElements.get('component-video')) {
  class ComponentVideo extends HTMLElement {
    constructor() {
      super()
      this.playButton = this.querySelector('.js-video-button')
      this.video = this.querySelector('.js-video-wrapper')
      this.playButton.addEventListener('click', () => {
        this.playVideo()
      })
    }

    playVideo() {
      this.video.classList.toggle('is-active')
    }
  }

  customElements.define('component-video', ComponentVideo)
}
